/*
 * Module for the Age Listing report criteria page
 */
rs.module("content/reports/criteria/agelistingcriteria",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var typeSelect = criteria.js(jsSelectors.typeSelect);
            var statusSelect = criteria.js(jsSelectors.statusSelect);

            // Get Select Helper for statusSelect since we're changing its options
            var statusSelectHelper = selectHelper.getHelper(statusSelect); 

            // register type drop down change event
            typeSelect.change(typeChanged);

            // On type selection change, retrieve and populate applicable statuses
            function typeChanged() {

                // get selected type
                var selectedType = typeSelect.val();

                // populate status selectpicker options based on selected type
                statusSelectHelper.loadOptionsFrom(backendUrl, { participationType: selectedType });      
            }
        }
      
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);